import React, { PropTypes, PureComponent } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {
  Button, Checkbox, Input,
  Textarea, Dropdown, Modal,
} from '../../../../shared';

import './styles.scss';

export class Unavailable extends PureComponent {
  constructor(props) {
    super(props);
    this.updateField = this.updateField.bind(this);

    // construct the dropdown options
    const options = ['days', 'weeks', 'months', 'years']
      .map(time => ({ name: time, value: time.slice(0, -1) }));

    this.state = {
      options,
      title: '',
      startDate: '',
      finishDate: '',
      allDay: false,
      startTime: '',
      finishTime: '',
      modal: null,
      repeating: false,
      interval: undefined,
      occurrences: undefined,
    };
  }

  async componentDidMount() {
    // we need to make a call to some endpoint to validate that we're online
    try {
      await fetch(`${__BASE_URL__}/login`, { mode: 'no-cors' });
    } catch (e) {
      //  no internet, or Tanda is down
      this.setState({
        modal: <Modal
          icontype="fa fa-exclamation-circle fa-4x"
          title="No Internet Connection"
          message="Sorry, you can't enter unavailability requests without internet."
          onClick={() => this.props.backwardActivity()}
        />,
      });
    }
  }

  onRepeating(value) {
    if (!this.state.repeating) {
      this.setState({ interval: 'day', occurrences: '1' });
    }
    this.updateField('repeating', value);
  }

  onAllDay(value) {
    if (!this.state.allDay) {
      this.setState({ startTime: '', finishTime: '' });
    }
    this.updateField('allDay', value);
  }

  getModal() {
    if (this.state.modal) {
      return this.state.modal;
    }
    return null;
  }

  updateField(field, value) {
    this.props.parentInteract();
    this.setState({
      [field]: value,
    });
  }

  async submitForm(event) {
    event.preventDefault();
    try {
      const res = await this.props.submitUnavailabilityRequest({
        ...this.state,
        user_id: this.props.currentUser.id,
      });
      if (res !== false) {
        this.props.showConfirm();
      }
    } catch (e) {
      // do similar to leave requests
      console.log(e);
    }
  }

  render() {
    return (
      <form className='unavailable' onSubmit={event => this.submitForm(event)}>
        {this.getModal()}
        <div className="unavailable-row">
          <div className='unavailable-field'><h3>START</h3></div>
          <div className='unavailable-field'><h3>END</h3></div>
        </div>

        <div className="unavailable-row">
          <Input
            className='unavailable-field'
            name='Date:'
            type="date"
            value={this.state.startDate}
            onChange={event => this.updateField('startDate', event.target.value)}
          />
          <Input
            className='unavailable-field'
            name='Date:'
            type="date"
            value={this.state.finishDate}
            onChange={event => this.updateField('finishDate', event.target.value)}
          />
        </div>

        {/* only shows on !state.allDay */
          !this.state.allDay ?
            <div className='unavailable-row'>
              <Input
                className='unavailable-field'
                name='Time:'
                type='time'
                value={this.state.startTime}
                onChange={event => this.updateField('startTime', event.target.value)}
              />
              <Input
                className='unavailable-field'
                name='Time:'
                type='time'
                value={this.state.finishTime}
                onChange={event => this.updateField('finishTime', event.target.value)}
              />
            </div>
            :
            undefined
        }

        <div className='unavailable-row small'>
          <div className='unavailable-field'>
            <Checkbox
              name="All day"
              className='unavailable-check'
              onClick={value => this.onAllDay(value)}
            />
          </div>
          <div className='unavailable-field'>
            <Checkbox
              name="Repeat"
              className='unavailable-check'
              onClick={value => this.onRepeating(value)}
            />
          </div>
        </div>

        {/* only shows on state.repeating */
          this.state.repeating ?
            <div>
              <p className='large-font'>Once a {this.state.interval} for:</p>
              <div className="unavailable-row">
                <Input
                  className='unavailable-field repeat'
                  type="number"
                  placeholder='0'
                  value={this.state.occurrences}
                  onChange={event => this.updateField('occurrences', event.target.value)}
                />
                <Dropdown
                  className='unavailable-dropdown repeat'
                  options={this.state.options}
                  value={this.state.interval}
                  onChange={event => this.updateField('interval', event.target.value)}
                />
              </div>
            </div>
            :
            undefined
        }

        <Textarea
          className='unavailable-text'
          name="Reason:"
          rows="3"
          value={this.state.title}
          onChange={event => this.updateField('title', event.target.value)}
        />

        <div className='unavailable-controls'>
          <ReactCSSTransitionGroup
            component='div'
            transitionName='fade'
            transitionAppear={false}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >

            {this.props.showNotification()}
          </ReactCSSTransitionGroup>

          <Button className='blue unavailable-button' type='submit'>
            <p>Add Unavailability</p>
          </Button>
        </div>
      </form>
    );
  }
}

Unavailable.propTypes = {
  backwardActivity: PropTypes.func,
  parentInteract: PropTypes.func,
  showNotification: PropTypes.func,
  submitUnavailabilityRequest: PropTypes.func,
  showConfirm: PropTypes.func,
};

export default Unavailable;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/requests/unavailable/main.jsx